<template>
    <div class="mt-1">
        <div>
            <table class="table table-bordered product-services-bundle-table">
                <thead>
                <tr>
                    <th scope="col" style="width: 10%;"></th>
                    <th scope="col" style="width: 55%;">Product</th>
                    <th scope="col" style="width: 25%;">Qty</th>
                    <th scope="col" style="width: 10%;"></th>
                </tr>
                </thead>
                <draggable v-model="bundle" tag="tbody">
                    <tr v-for="(item, key) in bundle">
                        <td style="cursor: all-scroll;"><i class="fa fa-align-justify px-1" aria-hidden="true"></i></td>
                        <td>
                            <multiselect
                                :options="productServicesOptions"
                                label="name"
                                v-model="item.data"
                                track-by="id"
                                :multiple="false"
                                groupValues="options"
                                groupLabel="label"
                                :groupSelect="false"
                                selectLabel=""
                                deselectLabel=""
                            >
                            </multiselect>
                        </td>
                        <td><input type="number" class="form-control" v-model="item.quantity" min="0" oninput="validity.valid||(value='');"></td>
                        <td><i class="fa fa-trash pointer px-1" aria-hidden="true" @click="removeBundleRow(key)"></i></td>
                    </tr>
                </draggable>
            </table>
        </div>
        <div class="mt-1">
            <span class="pointer underline" @click="addBundleRow">
                <i class="fa fa-plus px-1" aria-hidden="true"></i>
                Add Row
            </span>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import Multiselect from "vue-multiselect";

const bundleGeneric = {
    data: null,
    quantity: null
};
export default {
    name: 'pg-product-and-services-bundle-table',
    props: ['allPGProductServices'],
    components: {Multiselect, draggable},
    data() {
        return {
            productServices: [],
            products: [],
            services: [],
            bundle: [_.cloneDeep(bundleGeneric)]
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },
        productServicesOptions() {
            return [
                {
                    label: 'Product',
                    options: this.products
                },
                {
                    label: 'Service',
                    options: this.services
                }
            ]
        }
    },
    watch: {
        allPGProductServices: function() {
            let self = this;
            self.productServices = self.allPGProductServices;
            self.products = _.filter(self.productServices, ['type', 'product']);
            self.services = _.filter(self.productServices, ['type', 'service']);
        }
    },
    methods: {
        addBundleRow() {
            this.bundle.push({data: null, quantity: null});
        },
        removeBundleRow(key) {
            this.bundle.splice(key, 1);
        },
        resetProductServicesBundle() {
            this.bundle = [_.cloneDeep(bundleGeneric)];
        }
    }
}
</script>

<style scoped>
.product-services-bundle-table th, .product-services-bundle-table td {
    vertical-align: middle;
}
</style>
